export function generatePagination(
    currentPage: number,
    totalPages: number,
    siblingCount: number = 2,
    boundaryCount: number = siblingCount + 1
): number[][] {
    if (totalPages <= 0) return []
    if (siblingCount <= 0) throw new Error('pageRange must be greater than 0')

    const groups: number[][] = []
    const visiblePages = new Set<number>()

    // Add the first and last pages
    visiblePages.add(1)
    visiblePages.add(totalPages)

    // Add pages near the current page
    for (
        let i = Math.max(1, currentPage - siblingCount);
        i <= Math.min(totalPages, currentPage + siblingCount);
        i++
    ) {
        visiblePages.add(i)
    }

    // Add pages near the first and last pages
    for (let i = 1; i <= boundaryCount; i++) {
        if (i <= totalPages) visiblePages.add(i) // Pages near the start
        if (totalPages - i + 1 > 0) visiblePages.add(totalPages - i + 1) // Pages near the end
    }

    const sortedPages = Array.from(visiblePages).sort((a, b) => a - b)

    // Group pages into contiguous ranges
    let group: number[] = []
    for (let i = 0; i < sortedPages.length; i++) {
        if (i === 0 || sortedPages[i] === sortedPages[i - 1] + 1) {
            group.push(sortedPages[i])
        } else {
            groups.push(group)
            group = [sortedPages[i]]
        }
    }
    if (group.length > 0) groups.push(group)

    return groups
}
